export default __webpack_public_path__ + "static/media/2022-10-07-TikTok-Age-Limit-Streaming.e9fefafd.md";